import { analyticsService } from "@/common/services/analytics/analytics.service";
import { ArBox as ArBoxIcon } from "@whoppah/icons/24/ArBox";
import { showModal } from "@whoppah/ui/Modal2";
import ProductUtils from "./utils/ProductUtils";
import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";

type ProductDetailsArButtonProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsArButton = ({
  product,
}: ProductDetailsArButtonProps) => {
  const handleArClick = () => {
    showModal("google-ar", {
      product,
    });

    /** Trigger `launched_ar_pdp` event. */
    analyticsService.trackLaunchedArPdp();
  };

  const hasAr = ProductUtils.hasMobileARModel(product);

  if (!hasAr) {
    return null;
  }

  return (
    <button
      onClick={handleArClick}
      className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.1)]"
    >
      <ArBoxIcon className="text-grey-700" />
    </button>
  );
};
